export default __webpack_public_path__ + "static/media/BJ.cff206ab.svg";